import React, { PropsWithChildren } from "react";

function AirbnbResults(props: PropsWithChildren<any>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="21"
      fill="none"
      viewBox="0 0 20 21"
      {...props}>
      <path
        fill="#522398"
        stroke="#522398"
        strokeWidth="0.5"
        d="M10.022 15.773c-1.124-1.382-1.771-2.591-1.944-3.628-.994-3.802 4.838-3.802 3.887 0-.259 1.08-.907 2.246-1.943 3.628zm5.96 3.154c-1.813.777-3.628-.476-5.183-2.203 4.493-5.616 1.987-8.64-.777-8.64-2.376 0-3.715 2.03-3.197 4.363.302 1.253 1.08 2.678 2.376 4.277-1.426 1.555-2.635 2.289-3.672 2.375-2.16.346-3.888-1.77-3.11-3.93.648-1.685 4.838-9.979 5.01-10.41.692-1.297 1.124-2.506 2.55-2.506 1.425 0 1.9 1.123 2.634 2.592 1.556 3.066 3.845 7.689 4.968 10.323.562 1.426-.086 3.067-1.598 3.759zm2.031-5.875C12.441 1.172 12.138 1 10.022 1 8.035 1 7.214 2.382 6.35 4.153 1.77 13.354 1.296 14.65 1.296 14.737.173 17.76 2.419 20.352 5.14 20.352c.95 0 2.635-.26 4.882-2.678 2.505 2.765 4.362 2.678 4.838 2.678 2.721.043 4.967-2.592 3.844-5.615.043-.173-.691-1.685-.691-1.685z"></path>
    </svg>
  );
}

export default React.memo(AirbnbResults);
